import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0,
  },
  TextField: {
    maxWidth: '320px',
    height: 74,
  },
  labelTermino: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#484848',
  },
  labelTerminoDisabled: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#c1c1c1',
  },
}));

const PerfilView = React.forwardRef((props, ref) => {
  const {
    values: { name, email, phone, description, infoAdicional },
    handleSubmit,
    handleChange,
    touched,
    dirty,
    handleBlur,
    errors,
    isValid,
  } = props;

  const classes = useStyles();
  const onPreview = useRouteMatch('/preview');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: 16,
        padding: '0 10px',
        alignItems: 'center',
      }}
    >

      <TextField
        label="Nombre completo*"
        type="text"
        id="name"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={name}
        helperText={touched.name && errors.name ? errors.name : ''}
        error={touched.name && errors.name ? true : false}
        inputRef={ref}
        disabled={onPreview? true:false}
      />

      <TextField
        label="Correo*"
        type="email"
        id="email"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false}
        disabled={onPreview? true:false}
      />

      <TextField
        label="Número telefónico*"
        type="text"
        id="phone"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={phone}
        helperText={touched.phone && errors.phone ? errors.phone : ''}
        error={touched.phone && errors.phone ? true : false}
        disabled={onPreview? true:false}
      />
      <TextField
        label="Cuéntanos brevemente sobre tu caso*"
        type="text"
        id="description"
        variant="outlined"
        multiline={true}
        rows="4"
        onChange={props.countChar}
        inputProps={{
          maxLength: 300,
        }}
        style={{ height: 'auto' }}
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={description}
        helperText={
          touched.description && errors.description ? errors.description : ''
        }
        error={touched.description && errors.description ? true : false}
        disabled={onPreview? true:false}
      />

      <FormControlLabel
        classes={{
          root: classes.FormControlLabelRoot,
        }}
        control={
          <Checkbox
            name="infoAdicional"
            id="infoAdicional"
            checked={infoAdicional}
            onChange={event => {
              handleChange(event);
              handleBlur(event);
            }}
            onBlur={handleBlur}
            value="checked"
            color="primary"
            label="Gilad Gray"
            classes={{
              root: classes.checkPadding,
            }}
            disabled={onPreview? true:false}
          />
        }
        label={
          <>
            <p
              className={
                infoAdicional
                  ? classes.colorActiveCheck
                  : classes.colorActiveLabel
              }
            >
              <span className={
                  onPreview ?
                  classes.labelTerminoDisabled :
                  classes.labelTermino
                }
              >
                Quiero recibir noticias de contacta abogado
              </span>
            </p>
          </>
        }
      />

      <footer
        className={
          onPreview ?
          "cardContact_footerDisabled" :
          "cardContact_footer"
        }
      >
        <p style={{ margin: 0 }}>
          Al hacer clic en el botón Contactar, estás de acuerdo que has leido y
          aceptado los{' '}
          <a href="" target="">
            Términos y condiciones
          </a>{' '}
          y la{' '}
          <a href="" target="">
            Política de Privacidad
          </a>{' '}
          de Contacta Abogado.
        </p>
        <button className="cardContact_button" onClick={onPreview? null: handleSubmit} style={{cursor: onPreview? 'not-allowed':'pointer', backgroundColor: onPreview? '#7cd4d2':'#35b9b6'}}>
          Contactar
        </button>
      </footer>
    </div>
  );
});

export default PerfilView;
